const state = {
    signInReq: null,
    signInRes: null,
    jwtToken: null,
    frgtMail: null,
};

// getters
const getters = {
    GET_FORGOTPWD: (state) => {
        return state.frgtMail;
    },
    GET_JWT_TOKEN: (state) => {
        return state.jwtToken;
    },
    GET_SIGNIN_REQ: (state) => {
        return state.signInReq;
    },
    GET_SIGNIN_RES: (state) => {
        return state.signInRes;
    }
};

// actions
const actions = {
    CLEAR_AGT_LOGIN({ commit }) {
        commit("clearAgtLogin");
    },
    SET_JWT_TOKEN({ commit }, token) {
        commit("getJwtToken", token);
    },
    SET_FORGOTPWD({ commit }, fmail) {
        commit("getforgotPwd", fmail);
    },
    SET_SIGNIN_REQ({ commit }, req) {
        commit("getSignInReq", req);
    },
    SET_SIGNIN_RES({ commit }, res) {
        commit("getSignInRes", res);
    }
};
import { setAgtLoginResToLocal } from './../../../../applocalstorage/localStorage'
// mutations
const mutations = {

    clearAgtLogin(state) {
        state.signInReq = null;
        state.signInRes = null;
    },
    getforgotPwd(state, fmail) {
        state.frgtMail = fmail;
    },
    getJwtToken(state, token) {
        state.jwtToken = token;
    },
    getSignInReq(state, req) {
        state.signInReq = req;
    },
    getSignInRes(state, res) {
        state.signInRes = res;
        setAgtLoginResToLocal(JSON.stringify(res));
    },


};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};